var exports = {
  "XG": "ChannelAttachmentArea.module__scroller___bmRTZX",
  "IP": "ChannelAttachmentArea.module__channelAttachmentArea___bmRTZX",
  "Se": "ChannelAttachmentArea.module__upload___bmRTZX",
  "PO": "ChannelAttachmentArea.module__uploadContainer___bmRTZX",
  "il": "ChannelAttachmentArea.module__mediaContainer___bmRTZX",
  "BA": "ChannelAttachmentArea.module__clickableMedia___bmRTZX",
  "q2": "ChannelAttachmentArea.module__spoilerContainer___bmRTZX",
  "R": "ChannelAttachmentArea.module__hidden___bmRTZX",
  "rP": "ChannelAttachmentArea.module__hiddenSpoiler___bmRTZX",
  "pR": "ChannelAttachmentArea.module__spoilerWarning___bmRTZX",
  "Qx": "ChannelAttachmentArea.module__obscureWarning___bmRTZX",
  "Qu": "ChannelAttachmentArea.module__spoilerInnerContainer___bmRTZX",
  "CU": "ChannelAttachmentArea.module__spoilerWrapper___bmRTZX",
  "p6": "ChannelAttachmentArea.module__spoiler___bmRTZX",
  "$_": "ChannelAttachmentArea.module__media___bmRTZX",
  "_A": "ChannelAttachmentArea.module__tags___bmRTZX",
  "H6": "ChannelAttachmentArea.module__filenameContainer___bmRTZX",
  "iW": "ChannelAttachmentArea.module__filename___bmRTZX",
  "VF": "ChannelAttachmentArea.module__fileDetails___bmRTZX",
  "Ov": "ChannelAttachmentArea.module__fileSize___bmRTZX",
  "i_": "ChannelAttachmentArea.module__fileExtension___bmRTZX",
  "TC": "ChannelAttachmentArea.module__actionBarContainer___bmRTZX",
  "KY": "ChannelAttachmentArea.module__actionBar___bmRTZX" + " " + __webpack_require__(180357)["KE"],
  "x6": "ChannelAttachmentArea.module__button___bmRTZX" + " " + __webpack_require__(180357)["AS"],
  "OR": "ChannelAttachmentArea.module__danger___bmRTZX",
  "le": "ChannelAttachmentArea.module__actionBarIcon___bmRTZX",
  "s3": "ChannelAttachmentArea.module__altTag___bmRTZX",
  "Kk": "ChannelAttachmentArea.module__icon___bmRTZX",
  "Dp": "ChannelAttachmentArea.module__iconImage___bmRTZX",
  "vt": "ChannelAttachmentArea.module__videoModal___bmRTZX",
  "j": "ChannelAttachmentArea.module__videoContainer___bmRTZX",
  "yF": "ChannelAttachmentArea.module__divider___bmRTZX",
  "mg": "ChannelAttachmentArea.module__dropIndicatorLeft___bmRTZX",
  "l_": "ChannelAttachmentArea.module__dropIndicatorRight___bmRTZX",
};

module.exports = exports;
